import {Button, Form, Input, Select} from "antd";
import {useTranslation} from "react-i18next";
import "../../../core/style/grid-filter.css";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef} from "react";
import HospitalSelectBox from "../../hospital/HospitalSelectBox";
import ModalitySelectBox from "../../modality/ModalitySelectBox";

export default function DeviceFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const reset = () => {
        formRef.current.resetFields();
        onFilterPageSort({
            filter: {}
        })
    }

    const filter = (form) => {
        onFilterPageSort({
            filter: form
        })
    }

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
                // Grid üstündeki yatay filtre kartında durur (bkz. GridFilterCard).
                className={'grid-filter-form grid-filter-inline'}
            >
                <Form.Item
                    label={t('Search')}
                    name={'searchText'}
                    className={'grid-filter-wide'}
                >
                    <Input placeholder={t('Device Name, AE Title or IP')} allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Hospital')}
                    name={'hospitalId'}
                >
                    <HospitalSelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Modality')}
                    name={'modalityId'}
                >
                    <ModalitySelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Status')}
                    name={'isActive'}
                >
                    <Select allowClear>
                        <Select.Option value={null}>{t('All')}</Select.Option>
                        <Select.Option value={true}>{t('Active')}</Select.Option>
                        <Select.Option value={false}>{t('Passive')}</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item className={'grid-filter-actions'}>
                    <Button type={'primary'} htmlType="submit" >{t('Search')}</Button>
                    <Button onClick={reset}>{t('Reset')}</Button>
                </Form.Item>
            </Form>
        </>
    )
}
